import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ProgressBarModule } from 'primeng/progressbar';
import { map } from 'rxjs/operators';
import { WaitEnum, WaitService } from '../../service/wait.service';

@Component({
  selector: 'app-wait',
  template: `<div
    style="position: fixed; top: 0; left: 0; right: 0; z-index: 9999; height: 4px; background: transparent;"
  >
    @if (active$ | async) {
      <p-progressBar mode="indeterminate" styleClass="h-1!"></p-progressBar>
    }
  </div>`,
  imports: [ProgressBarModule, AsyncPipe],
  standalone: true,
})
export class WaitComponent {
  readonly waitService = inject(WaitService);

  readonly active$ = this.waitService.color$.pipe(
    map((color) => color !== undefined && color !== WaitEnum.undefinedColor),
  );
}
